<template>
    <div>
        <b-modal
            id="create"
            title="Criar Comentário"
            size="lg"
            hide-footer>

            <b-overlay :show="loading" rounded="sm">
                <b-form @submit="submit" @submit.stop.prevent>

                    <!-- Field -->
                    <b-form-group
                        label="Atalho / Gatilho do Comentário Geral"
                        description="Deve ser um nome curto que você consiga lembrar e repassar aos corretores.">

                        <!-- Input -->
                        <b-form-input
                            v-model="form.name"
                            :state="hasErrors('name', errors)"
                        ></b-form-input>

                        <!-- Error -->
                        <has-errors :errors="errors" name="name" />
                    </b-form-group>

                    <!-- Field -->
                    <b-form-group
                        label="Conteúdo do Comentário"
                        description="Qual o template que deseja inserir para que seja usado como base para o atalho escolhido.">

                        <!-- Input -->
                        <quill-editor
                            ref="myQuillEditor"
                            v-model="form.char"
                            :options="editorOption">
                        </quill-editor>

                        <!-- Error -->
                        <has-errors :errors="errors" name="char" />
                    </b-form-group>

                    <!-- Submit -->
                    <b-button type="submit" variant="primary" :disable="loading">
                        Criar Comentário
                    </b-button>
                </b-form>
            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

export default {
    components: {
        quillEditor
    },
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
                char: null
            },
            editorOption: {
                placeholder: 'Aqui você insere um comentário geral sobre o texto do aluno ...',
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'color': [] }, { 'background': [] },'link'],
                        ['clean', {'align': [] }]
                    ],
                }
            }
        }
    },
    methods: {

        submit() {
            this.loading = true;
            axios.post(this.endpoint, this.form)
                .then((result) => {
                    // Callback
                    this.$emit('created')

                    // Close Modal
                    this.$bvModal.hide('create')

                    // Message
                    this.$toast.success('Comentário criado com sucesso !')

                    // Clear Form
                    this.form = {
                        name: null,
                        char: null
                    }

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>

</style>
